import { signOut, type User } from "firebase/auth";
import { auth } from "../firebase.ts";

interface Props {
  user: User;
  code: string;
}

const COPY: Record<string, { title: string; body: string }> = {
  forbidden: {
    title: "You don't have admin access",
    body:
      "This Google account is signed in, but its email isn't on the admin allowlist. Ask Isaac to add you to ADMIN_EMAILS, then sign out and back in.",
  },
  admin_email_unverified: {
    title: "Your email isn't verified",
    body:
      "The admin gate requires a verified email from your sign-in provider. Sign out and try again with a different Google account.",
  },
  admin_disabled: {
    title: "Admin portal is closed",
    body:
      "The server's admin allowlist is empty (ADMIN_EMAILS unset). Until that's configured no one can use this admin UI — ask Isaac to set it on the API.",
  },
};

export function NoAccess({ user, code }: Props) {
  const meta = COPY[code] ?? COPY.forbidden!;
  return (
    <div className="signin-card no-access-card">
      <div className="signin-brand">
        <span className="brand-mark" aria-hidden="true" />
        <span className="brand-name">Expat Admin</span>
      </div>
      <h2>{meta.title}</h2>
      <p>{meta.body}</p>
      <button
        type="button"
        className="luna-btn luna-btn-outline luna-btn-lg"
        onClick={() => void signOut(auth)}
      >
        Sign out
      </button>
      <div className="signin-footer">
        signed in as {user.email ?? user.uid} · code <code>{code}</code>
      </div>
    </div>
  );
}
